import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultFlatShareRoomProperties,
  getSchemaForOtherFacilitiesByIntermediateRent,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentFlatShareRoomRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpaceFlatShareRoom,
    room: validationRules.roomFlatShareRoom,
    noBathrooms: validationRules.noBathrooms,
    roomSize: validationRules.roomSize,
    price: validationRules.price,
  },
  costs: {
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
    courtageNote: validationRules.courtageNote,
    courtage: validationRules.courtage,
  },
  otherFacilities: getSchemaForOtherFacilitiesByIntermediateRent,
  flatShareRoomProperties: defaultFlatShareRoomProperties,
  whoWeLookFor: {
    requestedGender: validationRules.requestedGender,
    numberOfRequestedFlatMates: validationRules.numberOfRequestedFlatMates,
    ageOfRequestedFrom: validationRules.ageOfRequestedFrom,
    ageOfRequestedTo: validationRules.ageOfRequestedTo,
    flatShareSize: validationRules.flatShareSize,
    numberOfMaleFlatMates: validationRules.numberOfMaleFlatMates,
    numberOfFemaleFlatMates: validationRules.numberOfFemaleFlatMates,
    ageOfFlatMatesFrom: validationRules.ageOfFlatMatesFrom,
    ageOfFlatMatesTo: validationRules.ageOfFlatMatesTo,
  },
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  apiSearchData: defaultApiSearchData,
}
